export interface MarkdownElement {
  type: 'text' | 'heading' | 'list' | 'listItem' | 'bold' | 'paragraph' | 'spacer';
  content: string;
  level?: number;
  spacing?: number;
  children?: MarkdownElement[];
}

export const parseMarkdown = (text: string): MarkdownElement[] => {
  const lines = text.split('\n');
  const elements: MarkdownElement[] = [];
  let currentList: MarkdownElement | null = null;
  let emptyLineCount = 0;

  for (let i = 0; i < lines.length; i++) {
    const line = lines[i].trim();

    if (!line) {
      emptyLineCount++;

      if (currentList) {
        elements.push(currentList);
        currentList = null;
      }
      continue;
    }

    if (emptyLineCount > 0) {
      elements.push({
        type: 'spacer',
        content: '',
        spacing: emptyLineCount,
      });
      emptyLineCount = 0;
    }

    if (line.startsWith('####')) {
      if (currentList) {
        elements.push(currentList);
        currentList = null;
      }
      elements.push({
        type: 'heading',
        content: line.replace(/^####\s+/, ''),
        level: 4,
      });
      continue;
    }

    if (line.startsWith('###')) {
      if (currentList) {
        elements.push(currentList);
        currentList = null;
      }
      elements.push({
        type: 'heading',
        content: line.replace(/^###\s+/, ''),
        level: 3,
      });
      continue;
    }

    if (line.startsWith('- ')) {
      const itemContent = line.replace(/^-\s+/, '');

      if (!currentList) {
        currentList = {
          type: 'list',
          content: '',
          children: [],
        };
      }

      currentList.children!.push({
        type: 'listItem',
        content: itemContent,
      });
      continue;
    }

    if (currentList) {
      elements.push(currentList);
      currentList = null;
    }

    elements.push({
      type: 'paragraph',
      content: line,
    });
  }

  if (currentList) {
    elements.push(currentList);
  }

  return elements;
};

export const processBoldText = (text: string): (string | { type: 'bold'; content: string })[] => {
  if (!text) return [];

  const parts = text.split(/(\*\*[^*]+\*\*)/);
  return parts
    .filter(part => part.length > 0)
    .map(part => {
      if (part.startsWith('**') && part.endsWith('**') && part.length > 4) {
        return {
          type: 'bold' as const,
          content: part.slice(2, -2),
        };
      }
      return part;
    });
};
